import { StudentVisaDocuments } from '../../../types';

const ALLOWED_VISA_TYPE = 'Student visa (Tier 4 General/Student Route)';
const ALLOWED_VISA_LEVEL = 'Bachelor (UG)';

export const isStudentVisaCalculationAllowed = (visa: StudentVisaDocuments) => {
  return visa.visaType === ALLOWED_VISA_TYPE && visa.level === ALLOWED_VISA_LEVEL;
};
